import React, { useEffect, useRef, useState } from "react";
import { Bold, Italic, Heading2, Heading3, List, ListOrdered, Quote, BookOpen, Undo2, Redo2 } from "lucide-react";

export default function RichEditor({ value, onChange, onInsertVerse, placeholder = "Escribí tu prédica…" }) {
  const ref = useRef(null);
  const [focused, setFocused] = useState(false);

  // One-time mount: inject initial HTML. Avoid resetting on every parent re-render
  // to prevent caret jumping while the pastor types.
  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || "")) {
      if (!focused) ref.current.innerHTML = value || "";
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const exec = (cmd, val = null) => {
    ref.current?.focus();
    document.execCommand(cmd, false, val);
    onChange(ref.current.innerHTML);
  };

  const handleInput = () => onChange(ref.current.innerHTML);

  return (
    <div className="flex flex-col gap-2" data-testid="rich-editor">
      <div className="flex flex-wrap gap-1 bg-white border border-[rgba(31,74,64,0.12)] rounded-lg p-1">
        <button onClick={() => exec("bold")} className="btn-ghost !min-h-9 !px-2" title="Negrita" data-testid="btn-bold"><Bold size={16} /></button>
        <button onClick={() => exec("italic")} className="btn-ghost !min-h-9 !px-2" title="Cursiva" data-testid="btn-italic"><Italic size={16} /></button>
        <span className="w-px bg-[rgba(31,74,64,0.12)] mx-1" />
        <button onClick={() => exec("formatBlock", "H2")} className="btn-ghost !min-h-9 !px-2" title="Título" data-testid="btn-h2"><Heading2 size={16} /></button>
        <button onClick={() => exec("formatBlock", "H3")} className="btn-ghost !min-h-9 !px-2" title="Subtítulo" data-testid="btn-h3"><Heading3 size={16} /></button>
        <button onClick={() => exec("formatBlock", "BLOCKQUOTE")} className="btn-ghost !min-h-9 !px-2" title="Ilustración" data-testid="btn-quote"><Quote size={16} /></button>
        <span className="w-px bg-[rgba(31,74,64,0.12)] mx-1" />
        <button onClick={() => exec("insertUnorderedList")} className="btn-ghost !min-h-9 !px-2" title="Puntos" data-testid="btn-ul"><List size={16} /></button>
        <button onClick={() => exec("insertOrderedList")} className="btn-ghost !min-h-9 !px-2" title="Numerada" data-testid="btn-ol"><ListOrdered size={16} /></button>
        <span className="w-px bg-[rgba(31,74,64,0.12)] mx-1" />
        <button onClick={onInsertVerse} className="btn-ghost !min-h-9 !px-3 text-sm" title="Insertar versículo" data-testid="btn-insert-verse"><BookOpen size={16} /> Insertar versículo</button>
        <span className="w-px bg-[rgba(31,74,64,0.12)] mx-1" />
        <button onClick={() => exec("undo")} className="btn-ghost !min-h-9 !px-2" data-testid="btn-undo"><Undo2 size={16} /></button>
        <button onClick={() => exec("redo")} className="btn-ghost !min-h-9 !px-2" data-testid="btn-redo"><Redo2 size={16} /></button>
      </div>
      <div
        ref={ref}
        contentEditable
        suppressContentEditableWarning
        className="rich-editor"
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        onInput={handleInput}
        data-placeholder={placeholder}
        data-testid="rich-editor-area"
      />
    </div>
  );
}
